import { ComponentType } from 'react';
import { StackNavigationOptions } from '@react-navigation/stack';

import OperatorPanelSettings from '@components/operatorPanel/components/OperatorPanelSettings';
import OperatorPanelSettingsMachineSelect from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsMachineSelect';
import OperatorPanelSettingsAddDevice from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsAddDevice';
import OperatorPanelScheduled from '@components/operatorPanel/components/OperatorPanelScheduled';
import OperatorPanelInformation from '@components/operatorPanel/components/OperatorPanelInformation';
import { OPERATOR_PANEL_INFORMATION_SCREENS } from '@components/operatorPanel/constants/operatorPanel.constants';
import OperatorPanelViewNCFile from '@components/operatorPanel/components/OperatorPanelViewNCFile';
import { BASIC_SCREEN_OPTIONS, BOTTOM_SHEET_OPTIONS, BOTTOM_SHEET_WITH_GESTURE_OPTIONS } from '@v2/pages/common/constants/base.constants';

export const operatorPanelLinking = {
  OperatorPanelViewNCFile: 'operator-panel/nc-file',
  OperatorPanelSettings: 'operator-panel/settings',
  OperatorPanelSettingsMachineSelect: 'operator-panel/settings/machine-select',
  OperatorPanelSettingsAddDevice: 'operator-panel/settings/add-device',
  [OPERATOR_PANEL_INFORMATION_SCREENS.Information]: {
    path: 'operator-panel/information',
    screens: {
      [OPERATOR_PANEL_INFORMATION_SCREENS.Jobs]: '/jobs',
      [OPERATOR_PANEL_INFORMATION_SCREENS.NcFiles]: '/nc-files',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Setup]: '/setup',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Tools]: '/tools',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Notes]: '/notes',
      [OPERATOR_PANEL_INFORMATION_SCREENS['2DDrawing']]: '/2d-drawing',
      [OPERATOR_PANEL_INFORMATION_SCREENS['3DDrawing']]: '/3d-drawing',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Clamping]: '/clamping',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Part]: '/part',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Material]: '/material',
      [OPERATOR_PANEL_INFORMATION_SCREENS.ProductionOrder]: '/production-order',
      [OPERATOR_PANEL_INFORMATION_SCREENS.Measurement]: '/measure',
      [OPERATOR_PANEL_INFORMATION_SCREENS.AllDocuments]: '/documents',
      [OPERATOR_PANEL_INFORMATION_SCREENS.SearchNCFiles]: '/search-nc-files',
      [OPERATOR_PANEL_INFORMATION_SCREENS.SearchHistory]: '/search-history',
    },
  },
  OperatorPanelScheduledScreen: 'operator-panel/scheduled',
};

export const operatorPanelScreens = [
  {
    name: 'OperatorPanelViewNCFile',
    Component: OperatorPanelViewNCFile,
    ...BASIC_SCREEN_OPTIONS,
  },
  {
    name: 'OperatorPanelSettings',
    Component: OperatorPanelSettings,
    options: BOTTOM_SHEET_OPTIONS,
  },
  {
    name: 'OperatorPanelSettingsMachineSelect',
    Component: OperatorPanelSettingsMachineSelect,
    ...BASIC_SCREEN_OPTIONS,
  },
  {
    name: 'OperatorPanelSettingsAddDevice',
    Component: OperatorPanelSettingsAddDevice,
    ...BASIC_SCREEN_OPTIONS,
  },
  {
    name: OPERATOR_PANEL_INFORMATION_SCREENS.Information,
    Component: OperatorPanelInformation,
    options: BOTTOM_SHEET_OPTIONS,
  },
  {
    name: 'OperatorPanelScheduledScreen',
    Component: OperatorPanelScheduled,
    options: BOTTOM_SHEET_WITH_GESTURE_OPTIONS,
  },
] satisfies {
  options: StackNavigationOptions;
  name: string;
  Component: ComponentType<any>;
}[];
